/* Cocooning Nuit — header transparent sur la home + sous-menus au survol.
   Adapté de la logique CP (transparent -> solide au scroll). Palette nuit. */
(function () {
  var body = document.body;

  /* Sous-menus ouverts AU SURVOL (desktop >=990px) : pose l'attribut [open] natif Dawn */
  function initHoverMenus() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      if (d.dataset.cbHover === '1') return;
      d.dataset.cbHover = '1';
      var t;
      d.addEventListener('mouseenter', function () { clearTimeout(t); d.setAttribute('open', ''); });
      d.addEventListener('mouseleave', function () { t = setTimeout(function () { d.removeAttribute('open'); }, 160); });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initHoverMenus); }
  else { initHoverMenus(); }
  window.addEventListener('load', initHoverMenus);

  /* Transparent -> solide : UNIQUEMENT sur la home (body.cb-transparent-header) */
  if (!body.classList.contains('cb-transparent-header')) return;

  function annHeight() {
    var a = document.querySelector('.cb-announce');
    return a ? a.offsetHeight : 0;
  }
  function setVars() {
    document.documentElement.style.setProperty('--cb-ann-h', annHeight() + 'px');
  }
  function onScroll() {
    var threshold = Math.max(annHeight() - 4, 10);
    if (window.scrollY > threshold) { body.classList.add('cb-scrolled'); }
    else { body.classList.remove('cb-scrolled'); }
  }
  function init() { setVars(); onScroll(); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { setVars(); onScroll(); }, { passive: true });
  window.addEventListener('load', setVars);
})();
